import type { ReactNode } from "react";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface InlineConfirmationProps {
  message: ReactNode;
  confirmLabel: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const InlineConfirmation = ({
  message,
  confirmLabel,
  isPending,
  onCancel,
  onConfirm,
}: InlineConfirmationProps) => (
  <Stack
    gap="sm"
    fullWidth
    className="pt-1"
    onClick={(event) => event.stopPropagation()}
  >
    <Typography variant="bodyW2" textColor="secondary">
      {message}
    </Typography>
    <Stack direction="row" gap="sm" align="center" justify="end" fullWidth>
      <Button
        variant="tertiary"
        size="xs"
        disabled={isPending}
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        variant="destructive"
        size="xs"
        loading={isPending}
        disabled={isPending}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </Stack>
  </Stack>
);
